import { FC } from "react";
import {
  ServiceCard,
  ServiceCardProps,
} from "../../components/cards/service-card/service-card";
import { Carousel } from "../../components/carousel/carousel";
import { Container } from "../../components/container/container";
import { SectionTitle } from "../../components/section-title/section-title";

import "./relevant-services.css";

export interface RelevantServicesProps {
  services?: ServiceCardProps[];
  title?: string;
  linkUrl?: string;
}

export const RelevantServices: FC<RelevantServicesProps> = ({
  services,
  title = "Acesso rápido",
  linkUrl = "/app/catalog/search/acesso-rapido",
}) => {
  if (!services?.length) {
    return null;
  }

  return (
    <div className="xvia-top-services">
      <Container className="xvia-relevant-services__container">
        <SectionTitle text={title} linkText={"Ver tudo"} linkUrl={linkUrl} />
        <Carousel>
          {services.map((service) => {
            return (
              <ServiceCard
                key={service.description}
                title={service.title}
                description={service.description}
                categoryIcon={service?.categoryIcon}
                profileIcon={service?.profileIcon}
                onClick={service.onClick}
                onClickFavorite={service.onClickFavorite}
                rating={service?.rating}
                type={service?.type}
                imageUrl={service?.imageUrl}
                isFavorite={service?.isFavorite}
                municipalityName={service?.municipalityName}
                targets={service?.targets}
                accessProfile={service?.accessProfile}
                slug={service?.slug}
                setSeverityAlert={service.setSeverityAlert}
                setOpenAlert={service.setOpenAlert}
                setMessageAlert={service.setMessageAlert}
              />
            );
          })}
        </Carousel>
      </Container>
    </div>
  );
};
